"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatGlobalIdentifier = void 0;
const formatGlobalIdentifier = (gi) => gi === null ? `no_global_identifier` : `${gi.identifier} (${gi.resource_server})`;
exports.formatGlobalIdentifier = formatGlobalIdentifier;
